{
  "title": "Cure Wounds",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "A creature you touch regains a number of hit points equal to 1d8 + your spellcasting ability modifier. This spell has no effect on undead or constructs.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the healing increases by 1d8 for each slot level above 1st."
  ],
  "spellLists": ["artificer", "bard", "cleric", "druid", "paladin", "ranger"]
}
